import { BaseRestRepository } from '~/repositories/baseRestRepository';
import { envConfig } from '~/utils/env';
import type { ContributionSettings } from '~/swagger/settings/Api';

const SETTINGS_BASE_URL = `${envConfig.service.settings}/company-portal/settings`;
const CONTRIBUTIONS_SETTINGS_URL = `${SETTINGS_BASE_URL}/contribution`;

export class contributionsSettingsRepository extends BaseRestRepository {
  public async changeContributionsSettings(payload: ContributionSettings) {
    const url = `${CONTRIBUTIONS_SETTINGS_URL}/company`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({ settings: payload }),
    });
    return this.getJsonResponse(response);
  }

  public async getAllContributionsSettings() {
    const url = `${CONTRIBUTIONS_SETTINGS_URL}/with-overrides`;
    const response = await this.fetchWithAuth(url);
    return this.getJsonResponse(response);
  }

  public async updateContributionsSettingsByLevel(level: string, levelId: string, payload: ContributionSettings) {
    const url = CONTRIBUTIONS_SETTINGS_URL;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify({
        settings: payload,
        targets: [{ level, levelId }],
      }),
    });
    return this.getJsonResponse(response);
  }

  public async deleteContributionsSettingsByLevel(level: string, levelId: string) {
    const url = `${CONTRIBUTIONS_SETTINGS_URL}/${level}/${levelId}`;
    await this.fetchWithAuth(url, {
      method: 'DELETE',
    });
  }
}
